"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const withStore_1 = __importDefault(require("../../decorators/withStore"));
const Wrapper = styled_components_1.default.div `
  width: 100%;
  padding: 1em;
  text-align: center;
  text-transform: uppercase;
  a {
    color: #999;
  }
`;
const Imprint = (props) => {
    if (props.imprintUrl) {
        return (react_1.default.createElement(Wrapper, null,
            react_1.default.createElement("a", { href: props.imprintUrl, target: "_blank", rel: "noreferrer" }, i18n_js_1.default.t("imprint"))));
    }
    return react_1.default.createElement(react_1.default.Fragment, null);
};
const mapStoreToProps = (store) => ({
    imprintUrl: store.getValue("imprintUrl"),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(Imprint);
